import { render } from "./PieChart.vue?vue&type=template&id=24369e63&scoped=true&ts=true"
import script from "./PieChart.vue?vue&type=script&lang=ts"
export * from "./PieChart.vue?vue&type=script&lang=ts"

import "./PieChart.vue?vue&type=style&index=0&id=24369e63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24369e63"]])

export default __exports__